export default "__VITE_ASSET__0dQDSPwx__"